/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./changeTrade.vue?vue&type=template&id=709c72cc&scoped=true&"
import script from "./changeTrade.vue?vue&type=script&lang=js&"
export * from "./changeTrade.vue?vue&type=script&lang=js&"
import style0 from "./changeTrade.vue?vue&type=style&index=0&id=709c72cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c72cc",
  null
  
)

export default component.exports